import { AbstractFullHouseProperties } from "@lib/titan2-slingo/dist/game/view/abstract/properties/AbstractFullHouseProperties";
import { SlingoStyle } from "@lib/titan2-slingo/dist/game/view/abstract/style/SlingoStyle";
import { ControlConstants } from "@lib/titan2/dist/game/control/constant/ControlConstants";
import { MouseBlockerProperties } from "@lib/titan2/dist/game/control/properties/MouseBlockerProperties";
import { SpriteProperties } from "@lib/titan2/dist/game/control/properties/SpriteProperties";
import { TextFieldProperties } from "@lib/titan2/dist/game/control/properties/TextFieldProperties";
import { Point } from "pixi.js";
import { deepEquals } from "../../../utils/deepEquals";
import { GameTextUtil } from "../../../utils/GameTextUtil";
import { GameLang } from "../lang/GameLang";
import { GameFontStyle } from "../style/GameFontStyle";
import { GameStyle } from "../style/GameStyle";
/**
 * Game-specific properties for the full house display.
 */
export class GameFullHouseProperties extends AbstractFullHouseProperties {
    constructor() {
        super();
        this.titleProperties = {
            text: new TextFieldProperties(GameFontStyle.FULL_HOUSE, null, GameLang.FULL_HOUSE, ControlConstants.CENTER, ControlConstants.CENTER, new Point(640, 300)),
            image: new SpriteProperties(GameStyle.FULL_HOUSE_FANCY, SlingoStyle.MODULE, undefined, new Point(0.75, 0.75), new Point(0.5, 0.5)),
            targetText: "Full House",
        };
        this.mouseBlockerProperties = new MouseBlockerProperties(0x000000, 0.6, true);
        GameTextUtil.centerProperties(this.titleProperties.text);
    }
    equals(other) {
        return deepEquals(other, this);
    }
}
//# sourceMappingURL=GameFullHouseProperties.js.map